"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var node_1 = require("../../support/node");
var InputContainer_1 = require("../../support/InputContainer");
var Elements_1 = require("../../support/Elements");
var EventStream_1 = require("../../event/EventStream");
var AbstractMap = /** @class */ (function () {
    function AbstractMap(spec) {
        var _this = this;
        this.defaultMarkerIcon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
        this.defaultSelectedMarkerIcon = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
        this.render = function (className) { return _this.init(_this.wrapper(className)); };
        this.getMarkerIconSrc = function () { return _this.spec.markerIcon ? _this.spec.markerIcon : _this.defaultMarkerIcon; };
        this.getSelectedMarkerIconSrc = function () { return _this.spec.selectedMarkerIcon ? _this.spec.selectedMarkerIcon : _this.defaultSelectedMarkerIcon; };
        this.includeScripts = function (scripts) { return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var scriptNodes, loadedScripts, countScripts, loaded;
            return __generator(this, function (_a) {
                scriptNodes = function (script) { return document.head.querySelector("[src=\"" + script + "\"]"); };
                loadedScripts = scripts.map(function (s) { return scriptNodes(s); }).filter(Boolean);
                if (scripts.length === loadedScripts.length) {
                    return [2 /*return*/, resolve()];
                }
                countScripts = 0;
                loaded = 0;
                scripts.forEach(function (script) {
                    if (!scriptNodes(script)) {
                        countScripts++;
                        var element = document.createElement('script');
                        element.onload = function () {
                            if (++loaded === countScripts)
                                resolve();
                        };
                        element.type = 'text/javascript';
                        element.src = script;
                        document.head.appendChild(element);
                    }
                });
                return [2 /*return*/];
            });
        }); }); };
        this.spec = spec;
    }
    AbstractMap.prototype.getZoom = function () {
        if (this.spec.zoom && this.spec.zoom >= this.minZoom && this.spec.zoom <= this.maxZoom)
            return this.spec.zoom;
        if (this.spec.zoom && this.spec.zoom > this.maxZoom)
            return this.maxZoom;
        if (this.spec.zoom && this.spec.zoom < this.minZoom)
            return this.minZoom;
        return this.defaultZoom;
    };
    AbstractMap.prototype.getCenter = function () {
        var _this = this;
        if (this.spec.centerBrowserLocation && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                return { lat: position.coords.latitude, lng: position.coords.longitude };
            }, function () {
                console.debug("Unable to init the " + _this.spec.mapType + " map with current position");
                return _this.spec.centerLat && _this.spec.centerLng ?
                    { lat: _this.spec.centerLat, lng: _this.spec.centerLng } :
                    { lat: 0, lng: 0 };
            });
        }
        return this.spec.centerLat && this.spec.centerLng ?
            { lat: this.spec.centerLat, lng: this.spec.centerLng } :
            { lat: 0, lng: 0 };
    };
    AbstractMap.prototype.setLabel = function (text, wrapper) {
        var labelWrapper = wrapper.find(".lto-map-label");
        if (!labelWrapper)
            return;
        labelWrapper.unwrap().innerHTML = text;
    };
    AbstractMap.prototype.wrapper = function (className) {
        var _this = this;
        var wrapper = node_1.default("div");
        wrapper.addClasses(className, "lto-map", "lto-left");
        wrapper.setAriaLabel(this.spec.ariaLabel);
        wrapper.setId(this.spec.id);
        wrapper.setName(this.spec.name);
        InputContainer_1.InputContainer.setRequiredAttribute(wrapper.unwrap(), this.spec.required);
        if (this.spec.class !== undefined)
            wrapper.addClasses(this.spec.class);
        var mapContainer = node_1.default("div");
        mapContainer.addClasses("lto-map-container");
        wrapper.appendChild(mapContainer);
        var label = node_1.default("div");
        label.addClasses("lto-map-label");
        wrapper.appendChild(label);
        EventStream_1.default.addListener(EventStream_1.default.SYSTEM_EVENT_TYPE_PREFIX + "map::reset::" + this.spec.name, function () {
            _this.resetAllMarkers();
            _this.setMarkersToValue(wrapper);
            _this.setLabel("", wrapper);
        });
        return wrapper;
    };
    AbstractMap.prototype.addMarkersToForm = function (wrapper, selectedMarkers) {
        var form = Elements_1.closestByClass(wrapper.unwrap(), ["lto-form"]);
        if (form)
            form.classList.remove("lto-submitable");
        if (selectedMarkers.length > 0) {
            if (form)
                form.classList.add("lto-submitable");
            wrapper.addDataAttributes({ value: JSON.stringify(selectedMarkers) });
        }
        else
            wrapper.removeAttributes("data-value");
    };
    AbstractMap.getMarkersFromSrc = function (src) { return fetch(src).then(function (data) { return data.json(); }).then(function (json) { return json.markers ? json.markers : null; }); };
    return AbstractMap;
}());
exports.AbstractMap = AbstractMap;
